import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BsLayoutSidebarInset } from "react-icons/bs"; // Sidebar Toggle Icon

interface SidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, setIsOpen }) => {
  const location = useLocation(); // Detect route changes

  return (
    <>
      {/* Sidebar Container - Overlays Page */}
      <div
        className={`fixed top-0 left-0 h-full bg-black/90 backdrop-blur-lg text-white shadow-lg flex flex-col transition-all duration-300 z-50 ${isOpen ? "w-64" : "w-0 md:w-20"
          }`}
      >
        {/* Sidebar Header */}
        <div
          className={`flex items-center px-6 py-6 transition-all ${isOpen ? "justify-between" : "justify-start"
            }`}
        >
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white rounded-full shadow-md"></div>
            {isOpen && (
              <h1 className="text-2xl font-bold text-white whitespace-nowrap">
                neUrO Ki
              </h1>
            )}
          </Link>

          {/* Add more space when Sidebar is Closed */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`text-white text-xl focus:outline-none transition-all ${isOpen ? "" : "ml-8" // Increase margin when sidebar is closed
              }`}
          >
            <BsLayoutSidebarInset />
          </button>
        </div>

        {/* Navigation Links */}
        <nav
          className={`flex flex-col space-y-0 px-4 sm:px-8 pt-1 text-lg font-medium transition-all duration-300 ${isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 hidden sm:flex"
            } justify-center h-full`}
        >
          {[
            { name: "Home", path: "/" },
            { name: "About", path: "/about" },
            { name: "Services", path: "/services" },
            { name: "Contact", path: "/contact" },
            { name: "Portfolio", path: "/portfolio" },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`relative transition-all duration-300 rounded-md px-2 py-2 ${location.pathname === item.path
                  ? "bg-gray-100/10 backdrop-blur-md text-white"
                  : "hover:bg-gray-700/5 hover:backdrop-blur-md hover:text-white"
                }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>

      {/* Mobile Overlay - Click to Close Sidebar */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;



















// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import { BsLayoutSidebarInset } from "react-icons/bs"; // Sidebar Toggle Icon

// interface SidebarProps {
//   isOpen: boolean;
//   setIsOpen: (isOpen: boolean) => void;
// }

// const Sidebar: React.FC<SidebarProps> = ({ isOpen, setIsOpen }) => {
//   const location = useLocation(); // Detect route changes

//   return (
//     <div className={`fixed top-0 left-0 h-full bg-black/90 backdrop-blur-lg text-white shadow-lg flex flex-col transition-all duration-300 w-64`}>
//       <div className="flex items-center justify-between px-6 py-6">
//         <Link to="/" className="flex items-center space-x-3">
//           {/* <div className="w-8 h-8 bg-gradient-to-br from-purple-500 via-blue-500 to-pink-500 rounded-full shadow-md"></div> */}
//           <div className="w-8 h-8 bg-gradient-to-br bg-white rounded-full shadow-md"></div>
//           <h1 className="text-2xl font-bold text-white whitespace-nowrap">neUrO Ki</h1>
//         </Link>

//         {/* Toggle Button (Only Affects Menu Items) */}
//         <button onClick={() => setIsOpen(!isOpen)} className="text-white">
//           <BsLayoutSidebarInset />
//         </button>
//       </div>

//       {/* Navigation Links (Toggled & Positioned Slightly Below Heading) */}
//       <nav
//         className={`flex flex-col space-y-2 px-8 pt-4 text-lg font-medium transition-all duration-300 ${
//           isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 hidden"
//         }justify-center h-full mt-[80%]`}
//       >
//         {[
//           { name: "Home", path: "/" },
//           { name: "About", path: "/about" },
//           { name: "Services", path: "/services" },
//           { name: "Contact", path: "/contact" },
//         ].map((item) => (
//           <Link
//             key={item.path}
//             to={item.path}
//             className={`relative transition-all duration-300 rounded-md px-2 py-1 ${
//               location.pathname === item.path
//                 ? "bg-gray-100/10 backdrop-blur-md text-white" // Transparent blurred active state
//                 : "hover:bg-gray-700/5 hover:backdrop-blur-md hover:text-white"
//             }`}
//           >
//             {item.name}
//           </Link>
//         ))}
//       </nav>
//     </div>
//   );
// };

// export default Sidebar;

// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { FiMenu, FiX } from "react-icons/fi";

// const Sidebar: React.FC = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(true); // Sidebar menu stays open by default
//   const location = useLocation(); // Detect route changes

//   // Toggle Menu Visibility
//   const toggleMenu = () => {
//     setIsMenuOpen((prev) => !prev);
//   };

//   return (
//     <>

//       {/* Sidebar Panel */}
//       <div className="fixed top-0 left-0 h-full w-64 bg-black/90 backdrop-blur-lg text-white shadow-lg flex flex-col">
//         {/* NeUrO Ki Branding (Always Visible) */}
//         <div className="flex items-center justify-between px-6 py-6 border-b border-gray-700">
//           <Link to="/" className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-gradient-to-br from-purple-500 via-blue-500 to-pink-500 rounded-full shadow-md"></div>
//             <h1 className="text-2xl font-extrabold text-white">neUrO Ki</h1>
//           </Link>

//           {/* Toggle Button (Only Affects Menu Items) */}
//           <button onClick={toggleMenu} className="text-white text-2xl">
//             {isMenuOpen ? <FiX /> : <FiMenu />}
//           </button>
//         </div>

//         {/* Navigation Links (Custom positioning & hover highlight) */}
//         <nav
//           className={`flex flex-col space-y-4 px-6 py-10 text-lg font-medium transition-all duration-300 ${
//             isMenuOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
//           }`}
//           style={{ marginTop: "50px" }} // Custom positioning (adjustable)
//         >
//           {[
//             { name: "Home", path: "/" },
//             { name: "About", path: "/about" },
//             { name: "Services", path: "/services" },
//             { name: "Contact", path: "/contact" },
//           ].map((item) => (
//             <Link
//               key={item.path}
//               to={item.path}
//               className={`relative transition-all duration-300 rounded-md px-4 py-2 ${
//                 location.pathname === item.path
//                   ? "bg-gray-800 text-white" // Active page highlight
//                   : "hover:bg-gray-700 hover:text-white"
//               }`}
//             >
//               {item.name}
//             </Link>
//           ))}
//         </nav>
//       </div>
//     </>
//   );
// };

// export default Sidebar;


// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FiMenu, FiX } from "react-icons/fi";

// const Sidebar: React.FC = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(true); // Sidebar is open by default

//   const toggleMenu = () => {
//     setIsMenuOpen((prev) => !prev);
//   };

//   return (
//     <>
//       {/* Floating Toggle Button (To open/close menu items) */}
//       {/* <button
//         onClick={toggleMenu}
//         className="fixed top-4 left-4 z-50 text-white text-3xl transition-transform duration-300"
//       >
//         {isMenuOpen ? <FiX /> : <FiMenu />}
//       </button> */}

//       {/* Sidebar Panel */}
//       <div className="fixed top-0 left-0 h-full w-64 bg-black/90 backdrop-blur-lg text-white shadow-lg">
//         {/* NeUrO Ki Branding (Always Visible) */}
//         <div className="flex items-center justify-between px-6 py-6 ">
//           <Link to="/" className="flex items-center space-x-3">
//             <div className="w-8 h-8 bg-gradient-to-br from-purple-500 via-blue-500 to-pink-500 rounded-full shadow-md"></div>
//             <h1 className="text-2xl font-extrabold text-white">neUrO Ki</h1>
//           </Link>

//           {/* Toggle Button (Only Affects Menu Items) */}
//           <button onClick={toggleMenu} className="text-white text-2xl">
//             {isMenuOpen ? <FiX /> : <FiMenu />}
//           </button>
//         </div>

//         {/* Navigation Links (Centered Vertically & Toggleable) */}
//         <nav
//           className={`flex flex-col space-y-3 p-6 text-lg font-medium transition-all duration-300 ${
//             isMenuOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
//           } justify-center h-full`}
//         >
//           <Link
//             to="/"
//             className="relative transition-all duration-300 hover:opacity-75"
//             onClick={toggleMenu}
//           >
//             Home
//           </Link>
//           <Link
//             to="/about"
//             className="relative transition-all duration-300 hover:opacity-75"
//             onClick={toggleMenu}
//           >
//             About
//           </Link>
//           <Link
//             to="/services"
//             className="relative transition-all duration-300 hover:opacity-75"
//             onClick={toggleMenu}
//           >
//             Services
//           </Link>
//           <Link
//             to="/contact"
//             className="relative transition-all duration-300 hover:opacity-75"
//             onClick={toggleMenu}
//           >
//             Contact
//           </Link>
//         </nav>
//       </div>
//     </>
//   );
// };

// export default Sidebar;


// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import { BsLayoutSidebarInset } from "react-icons/bs"; // Sidebar Toggle Icon

// interface SidebarProps {
//   isOpen: boolean;
//   setIsOpen: (isOpen: boolean) => void;
// }

// const Sidebar: React.FC<SidebarProps> = ({ isOpen, setIsOpen }) => {
//   const location = useLocation(); // Detect route changes

//   return (
//     <div className="fixed top-0 left-0 h-full w-64 bg-black/90 backdrop-blur-lg text-white shadow-lg flex flex-col transition-all duration-300">
//       {/* Branding Section (Always Visible) */}
//       <div className="flex items-center justify-between px-6 py-6 border-b border-gray-700">
//         <Link to="/" className="flex items-center space-x-3">
//           <div className="w-8 h-8 bg-gradient-to-br from-purple-500 via-blue-500 to-pink-500 rounded-full shadow-md"></div>
//           <h1 className="text-2xl font-extrabold text-white">neUrO Ki</h1>
//         </Link>

//         {/* Toggle Button (Only Affects Menu Items) */}
//         <button onClick={() => setIsOpen(!isOpen)} className="text-white text-2xl">
//           <BsLayoutSidebarInset />
//         </button>
//       </div>

//       {/* Navigation Links (Toggled & Positioned Slightly Below Heading) */}
//       <nav
//         className={`flex flex-col space-y-4 px-6 pt-8 text-lg font-medium transition-all duration-300 ${
//           isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
//         }`}
//       >
//         {[
//           { name: "Home", path: "/" },
//           { name: "About", path: "/about" },
//           { name: "Services", path: "/services" },
//           { name: "Contact", path: "/contact" },
//         ].map((item) => (
//           <Link
//             key={item.path}
//             to={item.path}
//             className={`relative transition-all duration-300 rounded-md px-4 py-2 ${
//               location.pathname === item.path
//                 ? "bg-gray-700/50 text-white" // Active page transparent highlight
//                 : "hover:bg-gray-700/30 hover:text-white"
//             }`}
//           >
//             {item.name}
//           </Link>
//         ))}
//       </nav>
//     </div>
//   );
// };

// export default Sidebar;